import { useEffect } from 'react';

const useWithScrollToTopOrHash = (timeout?: number) => {
  useEffect(() => {
    const hash = window.location.hash;
    if (hash && hash.length > 1) {
      const element = document.getElementById(hash.substring(1));
      if (element) {
        setTimeout(
          function () {
            element && element.scrollIntoView();
          },
          timeout ? timeout : 0,
        );
      } else {
        window.scrollTo(0, 0);
      }
    } else {
      window.scrollTo(0, 0);
    }
  });
};

export default useWithScrollToTopOrHash;
